import { useEffect } from 'react'

const useSetProductsFromCache = ({ checkOnKey, cache, categoryId, products, setProducts, setCurrentPage, setHasMore }) => {
  const cachedKeys = cache.keys();

  useEffect(() => {
    let index = 1;
    let updateArr = [];

    for (const currCachedKey of cachedKeys) {
      if (
        currCachedKey?.includes(checkOnKey) && currCachedKey?.includes(categoryId)
      ) {
        const selectedData = cache.get(currCachedKey)?.data;
        const selectedProducts = selectedData?.products;
        
        setHasMore(selectedData?.hasMore)
        index = selectedData?.currentPage;
        updateArr = [...updateArr, ...(selectedProducts?.length ? selectedProducts : [])]
      }
    }

    if (products?.length && updateArr?.length && index) {
      setProducts([...products, ...updateArr]);
      setCurrentPage(index);
    }
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    cache,
    categoryId
  ]);
}

export default useSetProductsFromCache